export class Metrics {
  constructor($) {
    console.info('Initializing Metrics');
    this.$ = $;
    this.$el = this.$('.td-container-metrics');
    if(this.$el.length === 0) {
      return;
    }

    this.loadMetricsPartial();
  }

  loadMetricsPartial() {
    this.$.get('/t/ajax/metrics/', (data) => {
        this.$el.html(data);
        let score = this.$el.find('#quality-score').val();
        this.initScorecard();
    }, 'html');
  }

  initScorecard() {
    this.$el.find('.scorecard-pagination-circle').on('click', function(e) {
      e.preventDefault();
      $('.scorecard-pagination-circle').removeClass('scorecard-active');
      let page = $(this).data('page');
      $(this).addClass('scorecard-active');

      $('.scorecard-page').slideUp();
      $('.scorecard-page.page-' + page).slideDown();
    });
  }
}



// WEBPACK FOOTER //
// ./style-guide-extends/js/translator-dashboard/metrics.js